import script from "./BookingMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingMobile.vue?vue&type=script&setup=true&lang=js"

import "./BookingMobile.vue?vue&type=style&index=0&id=5a05198c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a05198c"]])

export default __exports__